export const BASE_CMS_API = 'https://truebluecms.nsbluescope.com';
export const BASE_API = 'https://zacs-dc.nsbluescope.com';
// export const BASE_PORT_API = ':5004';
export const BASE_PORT_API = '';
export const BASE_PATH_API = '/api';

export const BASE_CMS_PORT_API = ':3000';
// export const BASE_CMS_PORT_API = '';
export const BASE_CMS_PATH_API = '/api';

export const TEXT_VERSION = '0.1.0';
export const FIREBASE_PUBLIC_STORAGE_STG_PATH = 'https://storage.googleapis.com/bluescope-stg.appspot.com';
export const FIREBASE_PUBLIC_STORAGE_PROD_PATH = 'https://storage.googleapis.com/bluescope-955e7.appspot.com';

export const DEV_HOSTNAME_LIST = ['localhost', 'https://nsbs-zacs-dev-bxech0gsg0frfpaq.z01.azurefd.net'];